import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addRequirementToPosition } from 'api/company/position/requirement'
import { requirementDataForPositionKey } from './keys'

type Response = Awaited<ReturnType<typeof addRequirementToPosition>>
type Variables = { requirementId: number }

export const useAddRequirementToPositionMutation = (
  positionId: number | null
) => {
  const queryClient = useQueryClient()
  return useMutation<Response, Error, Variables>({
    mutationFn: async ({ requirementId }) => {
      if (!positionId) {
        throw new Error('Position ID is required')
      }
      return await addRequirementToPosition({ positionId, requirementId })
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: requirementDataForPositionKey(positionId),
      })
    },
  })
}
